<template>
  <!-- 续费模块 -->
  <div class="buy">
    <div class="title">选购您需要的产品 👋</div>

    <!-- 产品续费 -->
    <!-- 卡密 -->
    <div class="pay">
      <Card class="cdk" title="卡密续费 💳 ">
        <template slot="content">
          <div class="tips">
            <i class="iconfont icon-guanyu"></i> 请输入您的卡密
          </div>
          <div class="cdkInput">
            <Minput
              icon="icon-a-Group93"
              placeholder="请输入卡密"
              v-model="cdk"
            ></Minput>
          </div>
          <div class="submit">
            <Mbutton
              @click="buyCdk"
              :disabled="canISubmit"
              :loading="cdkLoading"
            >
              提交
            </Mbutton>
          </div></template
        >
      </Card>
      <!-- 在线支付 -->
      <Card class="online" title="在线支付 ⚡">
        <template slot="content">
          <div class="tips">
            <i class="iconfont icon-guanyu"></i> 当前仅支持支付宝扫码支付
          </div>
          <div class="products">
            <div
              class="product shadow-1"
              :class="{
                isSelected: product == selectedProduct,
              }"
              v-for="(product, index) in products"
              :key="index"
              @click="onChangeProduct(product)"
            >
              <div class="left">{{ product.name }}</div>
              <div class="right">
                <span class="price">{{ product.price }}</span> ￥
              </div>
            </div>
          </div>
          <div class="qrcodes">
            <div class="qr">
              <img class="qrcode" :src="imgs" alt="" />
            </div>
            <div class="checkbtn">
              <div class="selected">
                <span class="name"> 当前选择产品：</span
                >{{ selectedProduct.name }}
              </div>
              <div class="lastTime">
                <span class="name">剩余有效时间：</span
                >{{ remaining.min + ":" + remaining.s }}
              </div>
              <div class="check" @click="onCheckRes">支付已经完成？点我</div>
            </div>
          </div></template
        >
      </Card>
    </div>

    <div class="title">续费记录 📜</div>
    <!-- 续费记录 -->
    <div class="history">
      <MTable
        :cols="cols"
        :data="data"
        align="center"
        :stripe="true"
        :line="true"
      ></MTable>
      <pagination
        :total="total"
        :pageSizes="pages"
        :currentSize="query.size"
        :currentPage="query.page"
        @sizeChange="sizeChange"
        @pageChange="pageChange"
      ></pagination>
    </div>
  </div>
</template>

<script>
import Card from "@/components/common/Card";
import Minput from "@/components/common/Input";
import Mbutton from "@/components/common/Button";

import Pagination from "../../components/common/Pagination/Pagination.vue";
import MTable from "@/components/common/Table/Table.vue";
import { getProduct } from "@/api/home";

export default {
  components: {
    Card,
    Pagination,
    MTable,
    Minput,
    Mbutton,
  },
  data() {
    return {
      products: [],
      selectedProduct: {},
      timeout: null,
      remain: {
        min: 30,
        s: 0,
      },
      cdk: "",
      cdkLoading: false,
      imgs: "http://sdfsdf.dev/200x200.png",
      total: 100,
      query: {
        page: 1,
        size: 10,
      },
      pages: [10, 20, 30, 50],
      data: [],
      cols: [
        {
          label: "index",
          field: "index",
        },
        {
          label: "产品名",
          field: "type",
          width: 150,
        },
        {
          label: "订单号",
          field: "orderid",
        },
        {
          label: "支付状态",
          field: "status",
        },
        {
          label: "IP地址",
          field: "ip",
        },
        {
          label: "创建时间",
          field: "time",
          sort: true,
        },
      ],
    };
  },
  created() {
    this.getProducts();
  },
  computed: {
    remaining: function () {
      return {
        min: this.num(this.remain.min),
        s: this.num(this.remain.s),
      };
    },
    canISubmit() {
      return Boolean(this.cdk) == false;
    },
  },
  methods: {
    queryData() {
      // this.getProducts();
    },
    getProducts() {
      getProduct().then(
        (res) => {
          this.products = res.data;
          this.onChangeProduct(this.products[0]);
        },
        (err) => {
          this.$tip.danger(err.msg || "获取产品列表失败");
        }
      );
    },
    buyCdk() {
      this.cdkLoading = true;
      setTimeout(() => {
        this.cdkLoading = false;
      }, 2000);
    },
    num(n) {
      return n >= 10 ? n : "0" + n;
    },
    onChangeProduct(product) {
      if (this.selectedProduct == product) {
        return;
      }
      this.selectedProduct = product;
      // 服务器创建订单、获取支付二维码
      console.log(product);
      //  重新设置倒计时
      this.resetInterval();
    },
    resetInterval() {
      if (this.timeout != null) {
        clearInterval(this.timeout);
        this.remain = {
          min: 30,
          s: 0,
        };
      }
      this.timeout = setInterval(() => {
        if (this.remain.min == 0 && this.remain.s == 0) {
          clearInterval(this.timeout);
        } else if (this.remain.s == 0 && this.remain.min > 0) {
          this.remain.s = 59;
          this.remain.min--;
        } else {
          this.remain.s--;
        }
      }, 1000);
    },
    onCheckRes() {
      console.log("发送请求，查看是否支付成功！");
    },
    sizeChange(value) {
      console.log("sizechange ", value);
      this.query.size = value;
      this.queryData();
    },
    pageChange(value) {
      console.log("pageChange ", value);
      this.query.page = value;
      this.queryData();
    },
  },
};
</script>

<style lang="less" scoped>
.buy {
  .title {
    font-size: 1.5rem;
    margin: 1rem;
    margin-top: 0;
  }
  .pay {
    display: flex;
    .cdk,
    .online {
      margin: 1rem;
    }
    .cdk {
      .submit {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .btn {
          width: 10rem;
        }
      }
    }

    .online {
      .products {
        display: flex;
        align-items: center;
        justify-content: space-around;
        .product {
          cursor: pointer;
          flex: 1;
          border-radius: 10px;
          padding: 0.5rem;
          background: #eeefff;
          margin: 0.5rem;
          .right {
            display: flex;
            padding: 0.5rem;
            align-items: center;
            justify-content: center;
            .price {
              font-size: 2rem;
            }
          }
        }
        .isSelected {
          background: #5932ea;
          color: #fff;
          .right {
            .price {
              color: #fff;
            }
          }
        }
      }
      .qrcodes {
        margin-top: 1rem;
        display: flex;
        .qr {
          width: 200px;
          height: 200px;
          .qrcode {
            width: 200px;
            height: 200px;
          }
        }
        .checkbtn {
          margin-left: 1rem;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .selected,
          .lastTime,
          .check {
            margin: 0.5rem;
            font-size: 1.2rem;
            .name {
              opacity: 0.8;
            }
          }
          .selected {
            color: rgb(89, 50, 234);
            .name {
              color: #000;
            }
          }
          .lastTime {
            color: red;
            .name {
              color: #000;
            }
          }
          .check {
            opacity: 0.8;
            cursor: pointer;
            font-size: 1rem;
          }
        }
      }
    }
  }
}
</style>
